import { useState } from 'react';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';
import {
	dismissProfessionalHomeGreetingForPageLoad,
	isProfessionalHomeGreetingDismissedForPageLoad,
} from '../utils/professionalHomeGreetingDismissed';

type ProfessionalHomeGreetingNotificationProps = {
	professionalGreetingName: string;
	canSchedulePatientSessions: boolean;
	onOpenTutorial: () => void;
};

const ProfessionalHomeGreetingNotification = ({
	professionalGreetingName,
	canSchedulePatientSessions,
	onOpenTutorial,
}: ProfessionalHomeGreetingNotificationProps) => {
	const [isVisible, setIsVisible] = useState(
		() => !isProfessionalHomeGreetingDismissedForPageLoad(),
	);

	if (!isVisible) return null;

	const handleDismiss = () => {
		dismissProfessionalHomeGreetingForPageLoad();
		setIsVisible(false);
	};

	return (
		<div
			role="status"
			className={cn(
				'pointer-events-auto absolute bottom-4 right-4 z-20 w-[min(20rem,calc(100vw-2rem))]',
				'rounded-xl border border-zinc-200 bg-white p-4 shadow-lg',
			)}
		>
			<div className="flex items-start gap-2">
				<div className="min-w-0 flex-1">
					<p className="text-sm font-bold text-zinc-800 md:text-base">
						Olá, {professionalGreetingName} 👋
					</p>
					<p className="mt-1 text-xs leading-relaxed text-zinc-500 md:text-sm">
						Aqui está sua agenda atualizada.
						{canSchedulePatientSessions ? (
							<>
								{' '}
								Tem alguma dúvida?{' '}
								<button
									type="button"
									onClick={onOpenTutorial}
									className="font-medium text-brand-purple underline-offset-2 transition-colors hover:text-brand-purple/80 hover:underline focus:outline-none"
								>
									Veja o tutorial
								</button>
								.
							</>
						) : null}
					</p>
				</div>
				<button
					type="button"
					onClick={handleDismiss}
					className="shrink-0 rounded-md p-1 text-zinc-400 transition-colors hover:bg-zinc-100 hover:text-zinc-600 focus:outline-none"
					aria-label="Fechar notificação"
				>
					<X className="size-4" strokeWidth={2.25} />
				</button>
			</div>
		</div>
	);
};

export { ProfessionalHomeGreetingNotification };
